class LipErlaHeroSlider {
  constructor(root) {
    this.root = root;
    this.slides = [...root.querySelectorAll('[data-lc-slide]')];
    this.dots = [...root.querySelectorAll('[data-lc-dot]')];
    this.index = 0;
    this.delay = Number(root.dataset.delay) || 5000;
    this.autoplay = root.dataset.autoplay === 'true';
    this.timer = null;
    this.videos = this.slides.map(slide => slide.querySelector('[data-lc-youtube]'));
    this.videos.forEach((video, index) => video?.addEventListener('load', () => {
      if (index === this.index) this.controlVideo(video, 'playVideo');
    }, { once: true }));
    if (this.slides.length < 2) return;
    root.querySelector('[data-lc-prev]')?.addEventListener('click', () => this.show(this.index - 1, true));
    root.querySelector('[data-lc-next]')?.addEventListener('click', () => this.show(this.index + 1, true));
    this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index, true)));
    root.addEventListener('mouseenter', () => this.stop());
    root.addEventListener('mouseleave', () => this.start());
    root.addEventListener('focusin', () => this.stop());
    root.addEventListener('focusout', () => this.start());
    let startX = 0;
    root.addEventListener('touchstart', event => { startX = event.touches[0].clientX; this.stop(); }, { passive: true });
    root.addEventListener('touchend', event => {
      const distance = event.changedTouches[0].clientX - startX;
      if (Math.abs(distance) > 45) this.show(this.index + (distance < 0 ? 1 : -1), true);
      this.start();
    }, { passive: true });
    document.addEventListener('visibilitychange', () => document.hidden ? this.stop() : this.start());
    this.start();
  }
  show(next, restart = false) {
    this.index = (next + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, index) => {
      const active = index === this.index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
      this.controlVideo(this.videos[index], active ? 'playVideo' : 'pauseVideo');
    });
    this.dots.forEach((dot, index) => {
      const active = index === this.index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', String(active));
    });
    if (restart) { this.stop(); this.start(); }
  }
  controlVideo(video, command) {
    if (!video?.contentWindow) return;
    video.contentWindow.postMessage(JSON.stringify({ event: 'command', func: command, args: [] }), '*');
  }
  start() {
    if (!this.autoplay || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.stop();
    this.timer = window.setInterval(() => this.show(this.index + 1), this.delay);
  }
  stop() { if (this.timer) window.clearInterval(this.timer); this.timer = null; }
}
const initLipErlaSliders = () => document.querySelectorAll('[data-lc-slider]').forEach(root => {
  if (!root.lipErlaSlider) root.lipErlaSlider = new LipErlaHeroSlider(root);
});
const initLipErlaCategories = () => document.querySelectorAll('[data-lc-category-track]').forEach(track => {
  if (track.dataset.carouselReady) return;
  track.dataset.carouselReady = 'true';
  const section = track.closest('section');
  const previous = section?.querySelector('[data-lc-category-prev]');
  const next = section?.querySelector('[data-lc-category-next]');
  const cards = [...track.querySelectorAll('.lc-category')];
  const amount = () => (cards[0]?.getBoundingClientRect().width || track.clientWidth * .82) + 14;
  const update = () => {
    if (previous) previous.disabled = track.scrollLeft < 8;
    if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
  };
  previous?.addEventListener('click', () => track.scrollBy({ left: -amount(), behavior: 'smooth' }));
  next?.addEventListener('click', () => track.scrollBy({ left: amount(), behavior: 'smooth' }));
  track.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  requestAnimationFrame(() => requestAnimationFrame(update));
  track.querySelectorAll('img').forEach(image => image.addEventListener('load', update, { once: true }));
});
const initLipErlaTrust = () => document.querySelectorAll('[data-lc-trust-track]').forEach(track => {
  if (track.dataset.trustReady) return;
  track.dataset.trustReady = 'true';
  const items = [...track.querySelectorAll('.lc-trust__item')];
  if (items.length < 2) return;
  const before = document.createDocumentFragment();
  const after = document.createDocumentFragment();
  items.forEach(item => {
    const firstClone = item.cloneNode(true);
    const lastClone = item.cloneNode(true);
    firstClone.dataset.trustClone = 'true';
    lastClone.dataset.trustClone = 'true';
    before.appendChild(firstClone);
    after.appendChild(lastClone);
  });
  track.insertBefore(before, track.firstChild);
  track.appendChild(after);
  const mobile = window.matchMedia('(max-width: 600px)');
  let start = 0;
  let setWidth = 0;
  let resetting = false;
  let frame = null;
  let lastTime = 0;
  let resumeTimer = null;
  const gap = () => parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
  const measure = () => {
    if (!mobile.matches) return;
    start = items[0].offsetLeft;
    setWidth = items[items.length - 1].offsetLeft + items[items.length - 1].offsetWidth + gap() - start;
  };
  const jump = position => {
    resetting = true;
    track.classList.add('is-jumping');
    track.scrollLeft = position;
    requestAnimationFrame(() => { track.classList.remove('is-jumping'); resetting = false; });
  };
  const center = () => { if (!mobile.matches) return; measure(); jump(start); };
  const preserve = () => {
    if (!mobile.matches || resetting || !setWidth) return;
    if (track.scrollLeft < start - setWidth * .55) jump(track.scrollLeft + setWidth);
    else if (track.scrollLeft > start + setWidth * .55) jump(track.scrollLeft - setWidth);
  };
  const stop = () => {
    if (frame) cancelAnimationFrame(frame);
    frame = null;
    lastTime = 0;
    if (resumeTimer) clearTimeout(resumeTimer);
    resumeTimer = null;
  };
  const move = time => {
    if (!lastTime) lastTime = time;
    const elapsed = Math.min(time - lastTime, 40);
    lastTime = time;
    track.scrollLeft += elapsed * .038;
    frame = requestAnimationFrame(move);
  };
  const startAuto = () => {
    stop();
    if (!mobile.matches || document.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    frame = requestAnimationFrame(move);
  };
  track.addEventListener('scroll', preserve, { passive: true });
  track.addEventListener('touchstart', stop, { passive: true });
  track.addEventListener('touchend', () => {
    if (resumeTimer) clearTimeout(resumeTimer);
    resumeTimer = setTimeout(startAuto, 1400);
  }, { passive: true });
  document.addEventListener('visibilitychange', () => document.hidden ? stop() : startAuto());
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => { if (mobile.matches) center(); else { stop(); track.scrollLeft = 0; } startAuto(); }, 120);
  }, { passive: true });
  requestAnimationFrame(() => requestAnimationFrame(() => { center(); startAuto(); }));
});
const initLipErlaProducts = () => document.querySelectorAll('[data-lc-product-carousel]').forEach(root => {
  if (root.dataset.carouselReady) return;
  root.dataset.carouselReady = 'true';
  const track = root.querySelector('[data-lc-product-track]');
  const previous = root.querySelector('[data-lc-product-prev]');
  const next = root.querySelector('[data-lc-product-next]');
  const cards = [...root.querySelectorAll('.lc-card')];
  if (!track || cards.length < 2) return;
  const loopOnMobile = root.dataset.mobileLoop === 'true';
  const shouldLoop = () => window.innerWidth > 900 || loopOnMobile;

  const before = document.createDocumentFragment();
  const after = document.createDocumentFragment();
  cards.forEach(card => {
    const firstClone = card.cloneNode(true);
    const lastClone = card.cloneNode(true);
    firstClone.dataset.loopClone = 'true';
    lastClone.dataset.loopClone = 'true';
    before.appendChild(firstClone);
    after.appendChild(lastClone);
  });
  track.insertBefore(before, track.firstChild);
  track.appendChild(after);

  let start = 0;
  let setWidth = 0;
  let resetting = false;
  const measure = () => {
    const first = cards[0];
    const last = cards[cards.length - 1];
    if (!first || !last) return;
    const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    start = first.offsetLeft;
    setWidth = last.offsetLeft + last.offsetWidth + gap - first.offsetLeft;
  };
  const jump = position => {
    resetting = true;
    track.classList.add('is-jumping');
    track.scrollLeft = position;
    requestAnimationFrame(() => {
      track.classList.remove('is-jumping');
      resetting = false;
    });
  };
  const centerOnOriginals = () => {
    if (!shouldLoop()) { jump(0); return; }
    measure();
    jump(start);
  };
  const preserveLoop = () => {
    if (!shouldLoop() || resetting || !setWidth) return;
    if (track.scrollLeft < start - setWidth * .55) jump(track.scrollLeft + setWidth);
    else if (track.scrollLeft > start + setWidth * .55) jump(track.scrollLeft - setWidth);
  };
  const amount = () => {
    const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    return (cards[0]?.getBoundingClientRect().width || track.clientWidth * .18) + gap;
  };
  previous?.addEventListener('click', () => track.scrollBy({ left: -amount(), behavior: 'smooth' }));
  next?.addEventListener('click', () => track.scrollBy({ left: amount(), behavior: 'smooth' }));
  track.addEventListener('scroll', preserveLoop, { passive: true });
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(centerOnOriginals, 120);
  }, { passive: true });
  requestAnimationFrame(() => requestAnimationFrame(centerOnOriginals));
});
const initLipErlaReels = () => document.querySelectorAll('[data-lc-reel-carousel]').forEach(root => {
  if (root.dataset.reelReady) return;
  root.dataset.reelReady = 'true';
  const track = root.querySelector('[data-lc-reel-track]');
  const previous = root.querySelector('[data-lc-reel-prev]');
  const next = root.querySelector('[data-lc-reel-next]');
  const cards = [...root.querySelectorAll('[data-lc-reel-card]')];
  if (!track || cards.length < 2) return;

  const before = document.createDocumentFragment();
  const after = document.createDocumentFragment();
  cards.forEach(card => {
    const firstClone = card.cloneNode(true);
    const lastClone = card.cloneNode(true);
    firstClone.dataset.reelClone = 'true';
    lastClone.dataset.reelClone = 'true';
    firstClone.removeAttribute('id');
    lastClone.removeAttribute('id');
    before.appendChild(firstClone);
    after.appendChild(lastClone);
  });
  track.insertBefore(before, track.firstChild);
  track.appendChild(after);

  const allCards = [...track.querySelectorAll('[data-lc-reel-card]')];
  const pauseCard = (card, reset = true) => {
    const video = card.querySelector('video');
    if (!video) return;
    video.pause();
    if (reset) { try { video.currentTime = 0; } catch (error) {} }
    card.classList.remove('is-playing');
    card.querySelector('[data-lc-reel-play]')?.setAttribute('aria-label', 'Play video');
  };
  const playCard = card => {
    const video = card.querySelector('video');
    if (!video) return;
    allCards.forEach(other => { if (other !== card) pauseCard(other); });
    video.muted = true;
    video.playsInline = true;
    const promise = video.play();
    if (promise) promise.then(() => {
      card.classList.add('is-playing');
      card.querySelector('[data-lc-reel-play]')?.setAttribute('aria-label', 'Pause video');
    }).catch(() => pauseCard(card, false));
  };
  allCards.forEach(card => {
    card.addEventListener('mouseenter', () => playCard(card));
    card.addEventListener('mouseleave', () => pauseCard(card));
    card.addEventListener('focusin', () => playCard(card));
    card.addEventListener('focusout', event => {
      if (!card.contains(event.relatedTarget)) pauseCard(card);
    });
    card.querySelector('[data-lc-reel-play]')?.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      card.classList.contains('is-playing') ? pauseCard(card) : playCard(card);
    });
  });

  let start = 0;
  let setWidth = 0;
  let resetting = false;
  const gap = () => parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
  const measure = () => {
    start = cards[0].offsetLeft;
    setWidth = cards[cards.length - 1].offsetLeft + cards[cards.length - 1].offsetWidth + gap() - start;
  };
  const jump = position => {
    resetting = true;
    track.classList.add('is-jumping');
    track.scrollLeft = position;
    requestAnimationFrame(() => {
      track.classList.remove('is-jumping');
      resetting = false;
    });
  };
  const centerOnOriginals = () => {
    allCards.forEach(card => pauseCard(card));
    measure();
    jump(start);
  };
  let loopTimer;
  const normalizeLoop = () => {
    if (resetting || !setWidth) return;
    const position = track.scrollLeft;
    if (position < start - setWidth * .55) jump(position + setWidth);
    else if (position > start + setWidth * .55) jump(position - setWidth);
  };
  const scheduleLoop = () => {
    clearTimeout(loopTimer);
    loopTimer = setTimeout(normalizeLoop, 140);
  };
  const amount = () => cards[0].getBoundingClientRect().width + gap();
  previous?.addEventListener('click', () => track.scrollBy({ left: -amount(), behavior: 'smooth' }));
  next?.addEventListener('click', () => track.scrollBy({ left: amount(), behavior: 'smooth' }));
  track.addEventListener('scroll', scheduleLoop, { passive: true });
  track.addEventListener('scrollend', normalizeLoop, { passive: true });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) allCards.forEach(card => pauseCard(card));
  });
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(centerOnOriginals, 120);
  }, { passive: true });
  requestAnimationFrame(() => requestAnimationFrame(centerOnOriginals));
});


const initLipErlaBrands = () => document.querySelectorAll('[data-lc-brand-carousel]').forEach(root => {
  if (root.dataset.brandReady) return;
  root.dataset.brandReady = 'true';
  const track = root.querySelector('[data-lc-brand-track]');
  const originals = [...root.querySelectorAll('[data-lc-brand-card]')];
  const previous = root.querySelector('[data-lc-brand-prev]');
  const next = root.querySelector('[data-lc-brand-next]');
  if (!track || originals.length < 2) return;

  const before = document.createDocumentFragment();
  const after = document.createDocumentFragment();
  originals.forEach(card => {
    const leading = card.cloneNode(true);
    const trailing = card.cloneNode(true);
    [leading, trailing].forEach(clone => {
      clone.dataset.brandClone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      clone.tabIndex = -1;
    });
    before.appendChild(leading);
    after.appendChild(trailing);
  });
  track.insertBefore(before, track.firstChild);
  track.appendChild(after);

  let start = 0;
  let setWidth = 0;
  let resetting = false;
  let loopTimer;
  const gap = () => parseFloat(getComputedStyle(track).gap) || 0;
  const measure = () => {
    start = originals[0].offsetLeft;
    setWidth = originals[originals.length - 1].offsetLeft + originals[originals.length - 1].offsetWidth + gap() - start;
  };
  const jump = position => {
    resetting = true;
    track.classList.add('is-jumping');
    track.scrollLeft = position;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      track.classList.remove('is-jumping');
      resetting = false;
    }));
  };
  const center = () => {
    measure();
    jump(start);
  };
  const normalize = () => {
    if (resetting || !setWidth) return;
    const position = track.scrollLeft;
    if (position < start - setWidth * .55) jump(position + setWidth);
    else if (position > start + setWidth * .55) jump(position - setWidth);
  };
  const scheduleNormalize = () => {
    clearTimeout(loopTimer);
    loopTimer = setTimeout(normalize, 140);
  };
  const amount = () => originals[0].getBoundingClientRect().width + gap();
  previous?.addEventListener('click', () => track.scrollBy({ left: -amount(), behavior: 'smooth' }));
  next?.addEventListener('click', () => track.scrollBy({ left: amount(), behavior: 'smooth' }));
  track.addEventListener('scroll', scheduleNormalize, { passive: true });
  track.addEventListener('scrollend', normalize, { passive: true });
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(center, 140);
  }, { passive: true });
  requestAnimationFrame(() => requestAnimationFrame(center));
});
const initLipErlaHome = () => { initLipErlaSliders(); initLipErlaCategories(); initLipErlaTrust(); initLipErlaProducts(); initLipErlaReels(); initLipErlaBrands(); };
document.addEventListener('DOMContentLoaded', initLipErlaHome);
document.addEventListener('shopify:section:load', initLipErlaHome);
